import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  AddressEntity,
  ApiApproveCompanyByIdParams,
  ApiGetCompaniesParams,
  AuctionEntity,
  BackendErrorEntity,
  CompanyEntity,
  CompanyWithRegistrationReportEntity,
  CreateAddressBodyDto,
  CreateCompanyDto,
  GetCompaniesResponseDto,
  GetCompanyInfoByTinResponseDto,
  UpdateCompanyBadUserBodyDto,
  UpdateCompanyDto,
  UploadCompanyRegistrationReportFileDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiCreateCompany = (
    createCompanyDto: MaybeRef<CreateCompanyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      createCompanyDto = unref(createCompanyDto);
      
      return fetchApiInstance<CompanyEntity>(
      {url: `/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyDto
    },
      options);
    }
  


export const getApiCreateCompanyMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompany>>, TError,{data: BodyType<CreateCompanyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompany>>, TError,{data: BodyType<CreateCompanyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCreateCompany>>, {data: BodyType<CreateCompanyDto>}> = (props) => {
          const {data} = props ?? {};

          return  apiCreateCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof apiCreateCompany>>>
    export type ApiCreateCompanyMutationBody = BodyType<CreateCompanyDto>
    export type ApiCreateCompanyMutationError = ErrorType<BackendErrorEntity>

    export const useApiCreateCompany = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompany>>, TError,{data: BodyType<CreateCompanyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCreateCompany>>,
        TError,
        {data: BodyType<CreateCompanyDto>},
        TContext
      > => {

      const mutationOptions = getApiCreateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetCompanies = (
    params?: MaybeRef<ApiGetCompaniesParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetCompaniesResponseDto>(
      {url: `/companies`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetCompaniesQueryKey = (params?: MaybeRef<ApiGetCompaniesParams>,) => {
    return ['companies', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetCompanies>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetCompaniesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanies>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetCompanies>>> = () => apiGetCompanies(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanies>>, TError, TData> 
}

export type ApiGetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetCompanies>>>
export type ApiGetCompaniesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetCompanies<TData = Awaited<ReturnType<typeof apiGetCompanies>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetCompaniesParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanies>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetCompany = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<CompanyWithRegistrationReportEntity>(
      {url: `/companies/${id}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetCompanyQueryKey = (id: MaybeRef<string | undefined | null>,) => {
    return ['companies',id] as const;
    }

    
export const getApiGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof apiGetCompany>>, TError = ErrorType<BackendErrorEntity>>(id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetCompanyQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetCompany>>> = () => apiGetCompany(id, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetCompany>>, TError, TData> 
}

export type ApiGetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetCompany>>>
export type ApiGetCompanyQueryError = ErrorType<BackendErrorEntity>



export function useApiGetCompany<TData = Awaited<ReturnType<typeof apiGetCompany>>, TError = ErrorType<BackendErrorEntity>>(
 id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompany>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetCompanyQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateCompany = (
    id: MaybeRef<string | undefined | null>,
    updateCompanyDto: MaybeRef<UpdateCompanyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
updateCompanyDto = unref(updateCompanyDto);
      
      return fetchApiInstance<CompanyEntity>(
      {url: `/companies/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDto
    },
      options);
    }
  


export const getApiUpdateCompanyMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompany>>, TError,{id: string;data: BodyType<UpdateCompanyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompany>>, TError,{id: string;data: BodyType<UpdateCompanyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateCompany>>, {id: string;data: BodyType<UpdateCompanyDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiUpdateCompany(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateCompany>>>
    export type ApiUpdateCompanyMutationBody = BodyType<UpdateCompanyDto>
    export type ApiUpdateCompanyMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateCompany = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompany>>, TError,{id: string;data: BodyType<UpdateCompanyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateCompany>>,
        TError,
        {id: string;data: BodyType<UpdateCompanyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDeleteCompany = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<CompanyEntity>(
      {url: `/companies/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteCompanyMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompany>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompany>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteCompany>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  apiDeleteCompany(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteCompany>>>
    
    export type ApiDeleteCompanyMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteCompany = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompany>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteCompany>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetCompanyParticipatedAuctions = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<AuctionEntity[]>(
      {url: `/companies/${id}/participatedAuctions`, method: 'GET'
    },
      options);
    }
  

export const getApiGetCompanyParticipatedAuctionsQueryKey = (id: MaybeRef<string | undefined | null>,) => {
    return ['companies',id,'participatedAuctions'] as const;
    }

    
export const getApiGetCompanyParticipatedAuctionsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>, TError = ErrorType<BackendErrorEntity>>(id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetCompanyParticipatedAuctionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>> = () => apiGetCompanyParticipatedAuctions(id, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>, TError, TData> 
}

export type ApiGetCompanyParticipatedAuctionsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>>
export type ApiGetCompanyParticipatedAuctionsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetCompanyParticipatedAuctions<TData = Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>, TError = ErrorType<BackendErrorEntity>>(
 id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyParticipatedAuctions>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetCompanyParticipatedAuctionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiApproveCompanyById = (
    id: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiApproveCompanyByIdParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
params = unref(params);
      
      return fetchApiInstance<CompanyEntity>(
      {url: `/companies/${id}/approve`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiApproveCompanyByIdQueryKey = (id: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiApproveCompanyByIdParams>,) => {
    return ['companies',id,'approve', ...(params ? [params]: [])] as const;
    }

    
export const getApiApproveCompanyByIdQueryOptions = <TData = Awaited<ReturnType<typeof apiApproveCompanyById>>, TError = ErrorType<BackendErrorEntity>>(id: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiApproveCompanyByIdParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiApproveCompanyById>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiApproveCompanyByIdQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiApproveCompanyById>>> = () => apiApproveCompanyById(id,params, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiApproveCompanyById>>, TError, TData> 
}

export type ApiApproveCompanyByIdQueryResult = NonNullable<Awaited<ReturnType<typeof apiApproveCompanyById>>>
export type ApiApproveCompanyByIdQueryError = ErrorType<BackendErrorEntity>



export function useApiApproveCompanyById<TData = Awaited<ReturnType<typeof apiApproveCompanyById>>, TError = ErrorType<BackendErrorEntity>>(
 id: MaybeRef<string | undefined | null>,
    params?: MaybeRef<ApiApproveCompanyByIdParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiApproveCompanyById>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiApproveCompanyByIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiCreateCompanyAddress = (
    id: MaybeRef<string | undefined | null>,
    createAddressBodyDto: MaybeRef<CreateAddressBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
createAddressBodyDto = unref(createAddressBodyDto);
      
      return fetchApiInstance<AddressEntity>(
      {url: `/companies/${id}/addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAddressBodyDto
    },
      options);
    }
  


export const getApiCreateCompanyAddressMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompanyAddress>>, TError,{id: string;data: BodyType<CreateAddressBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompanyAddress>>, TError,{id: string;data: BodyType<CreateAddressBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCreateCompanyAddress>>, {id: string;data: BodyType<CreateAddressBodyDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiCreateCompanyAddress(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCreateCompanyAddressMutationResult = NonNullable<Awaited<ReturnType<typeof apiCreateCompanyAddress>>>
    export type ApiCreateCompanyAddressMutationBody = BodyType<CreateAddressBodyDto>
    export type ApiCreateCompanyAddressMutationError = ErrorType<BackendErrorEntity>

    export const useApiCreateCompanyAddress = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCreateCompanyAddress>>, TError,{id: string;data: BodyType<CreateAddressBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiCreateCompanyAddress>>,
        TError,
        {id: string;data: BodyType<CreateAddressBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiCreateCompanyAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetCompanyAddresses = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<AddressEntity[]>(
      {url: `/companies/${id}/addresses`, method: 'GET'
    },
      options);
    }
  

export const getApiGetCompanyAddressesQueryKey = (id: MaybeRef<string | undefined | null>,) => {
    return ['companies',id,'addresses'] as const;
    }

    
export const getApiGetCompanyAddressesQueryOptions = <TData = Awaited<ReturnType<typeof apiGetCompanyAddresses>>, TError = ErrorType<BackendErrorEntity>>(id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyAddresses>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetCompanyAddressesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetCompanyAddresses>>> = () => apiGetCompanyAddresses(id, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(id))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyAddresses>>, TError, TData> 
}

export type ApiGetCompanyAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetCompanyAddresses>>>
export type ApiGetCompanyAddressesQueryError = ErrorType<BackendErrorEntity>



export function useApiGetCompanyAddresses<TData = Awaited<ReturnType<typeof apiGetCompanyAddresses>>, TError = ErrorType<BackendErrorEntity>>(
 id: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyAddresses>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetCompanyAddressesQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiDeleteCompanyRegistrationReport = (
    id: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
      
      return fetchApiInstance<void>(
      {url: `/companies/${id}/registrationReport`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDeleteCompanyRegistrationReportMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  apiDeleteCompanyRegistrationReport(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDeleteCompanyRegistrationReportMutationResult = NonNullable<Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>>
    
    export type ApiDeleteCompanyRegistrationReportMutationError = ErrorType<BackendErrorEntity>

    export const useApiDeleteCompanyRegistrationReport = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDeleteCompanyRegistrationReport>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getApiDeleteCompanyRegistrationReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDisconnectCompanyFromAddress = (
    companyId: MaybeRef<string | undefined | null>,
    addressId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      companyId = unref(companyId);
addressId = unref(addressId);
      
      return fetchApiInstance<AddressEntity>(
      {url: `/companies/${companyId}/addresses/${addressId}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiDisconnectCompanyFromAddressMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>, TError,{companyId: string;addressId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>, TError,{companyId: string;addressId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>, {companyId: string;addressId: string}> = (props) => {
          const {companyId,addressId} = props ?? {};

          return  apiDisconnectCompanyFromAddress(companyId,addressId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDisconnectCompanyFromAddressMutationResult = NonNullable<Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>>
    
    export type ApiDisconnectCompanyFromAddressMutationError = ErrorType<BackendErrorEntity>

    export const useApiDisconnectCompanyFromAddress = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>, TError,{companyId: string;addressId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDisconnectCompanyFromAddress>>,
        TError,
        {companyId: string;addressId: string},
        TContext
      > => {

      const mutationOptions = getApiDisconnectCompanyFromAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUpdateCompanyAddress = (
    companyId: MaybeRef<string | undefined | null>,
    addressId: MaybeRef<string | undefined | null>,
    createAddressBodyDto: MaybeRef<CreateAddressBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      companyId = unref(companyId);
addressId = unref(addressId);
createAddressBodyDto = unref(createAddressBodyDto);
      
      return fetchApiInstance<AddressEntity>(
      {url: `/companies/${companyId}/addresses/${addressId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createAddressBodyDto
    },
      options);
    }
  


export const getApiUpdateCompanyAddressMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyAddress>>, TError,{companyId: string;addressId: string;data: BodyType<CreateAddressBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyAddress>>, TError,{companyId: string;addressId: string;data: BodyType<CreateAddressBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateCompanyAddress>>, {companyId: string;addressId: string;data: BodyType<CreateAddressBodyDto>}> = (props) => {
          const {companyId,addressId,data} = props ?? {};

          return  apiUpdateCompanyAddress(companyId,addressId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateCompanyAddressMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateCompanyAddress>>>
    export type ApiUpdateCompanyAddressMutationBody = BodyType<CreateAddressBodyDto>
    export type ApiUpdateCompanyAddressMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateCompanyAddress = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyAddress>>, TError,{companyId: string;addressId: string;data: BodyType<CreateAddressBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateCompanyAddress>>,
        TError,
        {companyId: string;addressId: string;data: BodyType<CreateAddressBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateCompanyAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiEnrichCompanyByTin = (
    countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      countryCode = unref(countryCode);
tin = unref(tin);
      
      return fetchApiInstance<GetCompanyInfoByTinResponseDto>(
      {url: `/companies/enrichByTin/${countryCode}/${tin}`, method: 'GET'
    },
      options);
    }
  

export const getApiEnrichCompanyByTinQueryKey = (countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>,) => {
    return ['companies','enrichByTin',countryCode,tin] as const;
    }

    
export const getApiEnrichCompanyByTinQueryOptions = <TData = Awaited<ReturnType<typeof apiEnrichCompanyByTin>>, TError = ErrorType<BackendErrorEntity>>(countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiEnrichCompanyByTin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiEnrichCompanyByTinQueryKey(countryCode,tin);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEnrichCompanyByTin>>> = () => apiEnrichCompanyByTin(countryCode,tin, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(countryCode) && unref(tin))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiEnrichCompanyByTin>>, TError, TData> 
}

export type ApiEnrichCompanyByTinQueryResult = NonNullable<Awaited<ReturnType<typeof apiEnrichCompanyByTin>>>
export type ApiEnrichCompanyByTinQueryError = ErrorType<BackendErrorEntity>



export function useApiEnrichCompanyByTin<TData = Awaited<ReturnType<typeof apiEnrichCompanyByTin>>, TError = ErrorType<BackendErrorEntity>>(
 countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiEnrichCompanyByTin>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiEnrichCompanyByTinQueryOptions(countryCode,tin,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetCompanyInfo = (
    countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      countryCode = unref(countryCode);
tin = unref(tin);
      
      return fetchApiInstance<GetCompanyInfoByTinResponseDto>(
      {url: `/companies/companyInfo/${countryCode}/${tin}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetCompanyInfoQueryKey = (countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>,) => {
    return ['companies','companyInfo',countryCode,tin] as const;
    }

    
export const getApiGetCompanyInfoQueryOptions = <TData = Awaited<ReturnType<typeof apiGetCompanyInfo>>, TError = ErrorType<BackendErrorEntity>>(countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyInfo>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetCompanyInfoQueryKey(countryCode,tin);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetCompanyInfo>>> = () => apiGetCompanyInfo(countryCode,tin, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(countryCode) && unref(tin))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyInfo>>, TError, TData> 
}

export type ApiGetCompanyInfoQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetCompanyInfo>>>
export type ApiGetCompanyInfoQueryError = ErrorType<BackendErrorEntity>



export function useApiGetCompanyInfo<TData = Awaited<ReturnType<typeof apiGetCompanyInfo>>, TError = ErrorType<BackendErrorEntity>>(
 countryCode: MaybeRef<string | undefined | null>,
    tin: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetCompanyInfo>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetCompanyInfoQueryOptions(countryCode,tin,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateCompanyBadUser = (
    id: MaybeRef<string | undefined | null>,
    updateCompanyBadUserBodyDto: MaybeRef<UpdateCompanyBadUserBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
updateCompanyBadUserBodyDto = unref(updateCompanyBadUserBodyDto);
      
      return fetchApiInstance<CompanyEntity>(
      {url: `/companies/${id}/badUser`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyBadUserBodyDto
    },
      options);
    }
  


export const getApiUpdateCompanyBadUserMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>, TError,{id: string;data: BodyType<UpdateCompanyBadUserBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>, TError,{id: string;data: BodyType<UpdateCompanyBadUserBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>, {id: string;data: BodyType<UpdateCompanyBadUserBodyDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiUpdateCompanyBadUser(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateCompanyBadUserMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>>
    export type ApiUpdateCompanyBadUserMutationBody = BodyType<UpdateCompanyBadUserBodyDto>
    export type ApiUpdateCompanyBadUserMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateCompanyBadUser = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>, TError,{id: string;data: BodyType<UpdateCompanyBadUserBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateCompanyBadUser>>,
        TError,
        {id: string;data: BodyType<UpdateCompanyBadUserBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateCompanyBadUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiUploadCompanyRegistrationReport = (
    id: MaybeRef<string | undefined | null>,
    uploadCompanyRegistrationReportFileDto: MaybeRef<UploadCompanyRegistrationReportFileDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      id = unref(id);
uploadCompanyRegistrationReportFileDto = unref(uploadCompanyRegistrationReportFileDto);
      const formData = new FormData();
formData.append('file', uploadCompanyRegistrationReportFileDto.file)
if(uploadCompanyRegistrationReportFileDto.issueDate !== undefined && uploadCompanyRegistrationReportFileDto.issueDate !== null) {
 formData.append('issueDate', uploadCompanyRegistrationReportFileDto.issueDate)
 }

      return fetchApiInstance<CompanyWithRegistrationReportEntity>(
      {url: `/companies/${id}/uploadCompanyRegistrationReportFile`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getApiUploadCompanyRegistrationReportMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>, TError,{id: string;data: BodyType<UploadCompanyRegistrationReportFileDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>, TError,{id: string;data: BodyType<UploadCompanyRegistrationReportFileDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>, {id: string;data: BodyType<UploadCompanyRegistrationReportFileDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiUploadCompanyRegistrationReport(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUploadCompanyRegistrationReportMutationResult = NonNullable<Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>>
    export type ApiUploadCompanyRegistrationReportMutationBody = BodyType<UploadCompanyRegistrationReportFileDto>
    export type ApiUploadCompanyRegistrationReportMutationError = ErrorType<BackendErrorEntity>

    export const useApiUploadCompanyRegistrationReport = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>, TError,{id: string;data: BodyType<UploadCompanyRegistrationReportFileDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUploadCompanyRegistrationReport>>,
        TError,
        {id: string;data: BodyType<UploadCompanyRegistrationReportFileDto>},
        TContext
      > => {

      const mutationOptions = getApiUploadCompanyRegistrationReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    